import { render, staticRenderFns } from "./MagAddValues.vue?vue&type=template&id=5ff949af"
import script from "./MagAddValues.vue?vue&type=script&lang=js"
export * from "./MagAddValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports